import { SuperAction } from "../SuperAction";

export class OnChangeFormValue extends SuperAction {};

export function changeFormValue(reducerName, fieldName, fieldValue) {
  return new OnChangeFormValue({ reducerName, fieldName, fieldValue });
}